import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import {
  initialCommAutoDriverProfile,
  initialCommAutoDriverProfileState,
} from "./commAutoDriverProfile.types";
import {
  fetchCommAutoDriverProfileByIdAsync,
  fetchCommAutoDriverProfileListAsync,
  upsertCommAutoDriverProfileAsync,
} from "./commAutoDriverProfileActions";

const commAutoDriverProfileSlice = createSlice({
  name: "commAutoDriverProfile",
  initialState: initialCommAutoDriverProfileState,
  reducers: {
    clearCommAutoDriverProfileState: (state) => {
      return initialCommAutoDriverProfileState;
    },
    clearCommAutoDriverProfile: (state) => {
      state.driverProfile = initialCommAutoDriverProfile;
      state.driverProfileLoading = LoadState.NotLoaded;
    },
  },
  extraReducers: (builder) => {
    // List
    builder.addCase(fetchCommAutoDriverProfileListAsync.pending, (state) => {
      state.loading = LoadState.InProgress;
      state.list = [];
    });
    builder.addCase(
      fetchCommAutoDriverProfileListAsync.fulfilled,
      (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      }
    );
    builder.addCase(fetchCommAutoDriverProfileListAsync.rejected, (state) => {
      state.loading = LoadState.Failed;
    });

    // Fetch by ID
    builder.addCase(fetchCommAutoDriverProfileByIdAsync.pending, (state) => {
      state.driverProfileLoading = LoadState.InProgress;
    });
    builder.addCase(
      fetchCommAutoDriverProfileByIdAsync.fulfilled,
      (state, action) => {
        state.driverProfileLoading = LoadState.Loaded;
        state.driverProfile = action.payload;
      }
    );
    builder.addCase(fetchCommAutoDriverProfileByIdAsync.rejected, (state) => {
      state.driverProfileLoading = LoadState.Failed;
    });

    // Upsert
    builder.addCase(upsertCommAutoDriverProfileAsync.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(upsertCommAutoDriverProfileAsync.fulfilled, (state) => {
      state.saveLoading = false;
    });
    builder.addCase(upsertCommAutoDriverProfileAsync.rejected, (state) => {
      state.saveLoading = false;
    });
  },
});

export const { clearCommAutoDriverProfileState, clearCommAutoDriverProfile } =
  commAutoDriverProfileSlice.actions;

export const commAutoDriverProfileReducer =
  commAutoDriverProfileSlice.reducer;
